























import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { ReportType } from "@/store/enum/reportType";
import { Component, Vue } from "vue-property-decorator";
import { ReportModule } from "@/store/modules/report.store";
import { AssetEnum, AssetRepository } from "@/lib/AssetRepository";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ReportTypeSelector extends Vue implements IReportStep {
  header: IReportHeaderData = {
    title: "report.reportTypeSelector.title",
    description: "report.reportTypeSelector.description"
  };

  AssetEnum = AssetEnum;

  car = ReportType.CAR;
  container = ReportType.CONTAINER;

  reportTypeConfiguration = [
    {
      type: ReportType.CAR,
      image: AssetRepository.getAsset(this.$vuetify.theme.dark, AssetEnum.carFrontLeft),
      label: "Auto"
    },
    {
      type: ReportType.CONTAINER,
      image: AssetRepository.getAsset(this.$vuetify.theme.dark, AssetEnum.containerFrontLeft),
      label: "Container"
    },
    {
      type: ReportType.MOTORBIKE,
      image: AssetRepository.getAsset(this.$vuetify.theme.dark, AssetEnum.motorbikeFrontLeft),
      label: "Motorrad"
    }
  ];

  get activeReportTypeConfigurations() {
    return this.reportTypeConfiguration.filter(item => ReportModule.activeReportTypes.includes(item.type));
  }

  get reportType() {
    return ReportModule.reportType;
  }

  set reportType(value: ReportType) {
    ReportModule.setReportType(value);
  }

  get isDone() {
    return true;
  }

  get color() {
    return getDefaultPartnerColor();
  }
}
